	export enum RecommendationEquilibriumType {
		D = 1,
		U = 2,
		V = 3,
		N = 4
	}
